import script from "./AllocationShare.vue?vue&type=script&setup=true&lang=js"
export * from "./AllocationShare.vue?vue&type=script&setup=true&lang=js"

import "./AllocationShare.vue?vue&type=style&index=0&id=4374269a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4374269a"]])

export default __exports__